import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";


export default {
    methods: {
    },

    beforeMount() {

    }
}


// WEBPACK FOOTER //
// ./src/components/Account/Terms.js